import { useContext } from 'react'

import {
  DashboardModuleListItem,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationBookingItem from '@hooks/usePublicationBookingItem'

const BookingListItem = (props: { publicationBookingItemId: number }) => {
  const { publicationBookingItemId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      getSelectableListItemProps,
    },
  } = pageContext

  const {
    campaign,
    order,
  } = usePublicationBookingItem({ id: publicationBookingItemId })

  const listItemProps = getSelectableListItemProps(publicationBookingItemId)

  return (
    <DashboardModuleListItem
      childrenHolderProps={{ alignItems: 'center', maxWidth: '60%' }}
      showCheckbox
      // @ts-expect-error TS2339
      title={`${campaign?.address}, ${campaign?.suburb_name}`}
      {...listItemProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {/*
         // @ts-expect-error TS2339 */}
        {order?.title}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default BookingListItem
